// extracted by mini-css-extract-plugin
export var pillWrapper = "_qc-0";
export var showOverflow = "_qc-1";